module.exports = __webpack_public_path__ + "img/swift-sport-2023.8c2ff038.png";